import type { ComboBoxOptionComponentProps } from '../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import type { PortOption } from '../PortDetailSelect';
import { PortOptionType } from '../PortOptionType';

export const PortReachSeparator = ({ option }: ComboBoxOptionComponentProps<PortOption>) => {
    if (option.type !== PortOptionType.SCHEDULE || !option.showReachSeparator) {
        return null;
    }

    return (
        <Box alignItems="center" display="flex" minHeight={32} paddingX={12} paddingY={8}>
            <Text variant="extraSmall" color="foreground.muted" fontWeight={600}>
                {translate('portSelect.reach.sectionHeading')}
            </Text>
        </Box>
    );
};
